/*
This is a template for environment configuration.

Copy this file and rename it to `environment.ts` for development or/and `environment.prod.ts` for production (set production to true).
Update the values as needed for each environment.
*/
export const environment = {
    production: false,

    // Sentry
    sentryDsn: 'sentry_dsn',
    sentryTracePropagationTargets: ["localhost"],

    // API
    apiUrl: 'https://dev.neox.energy/api', // Base API URL (ensure no trailing slash to avoid URL formatting issues)
    wsUrl: 'wss://dev.neox.energy/ws',
    clientId: 'web_app',
    clientSecret: 'web_app',

    sessionTokenExcludedUrls: ['solar.googleapis.com', 'lh3.googleusercontent.com', 'amazonaws.com'],
    authTokenExcludedUrls: ['solar.googleapis.com', 'lh3.googleusercontent.com', 'amazonaws.com'],

    googleSolarApiKey: 'AIzaSyDfURuqRD5ybibZvKetFKBtXYPhEgllWCQ',

    // Stripe
    stripePublishableKey: 'pk_test_51QrzGxBMzC08FT9w3rJV5CWHAH0IU6IgtCR4g6B8Eda2e3ABiIbSCR96S48cHQPTs9yoW77qYkuY79eFnFJqwInV00krwg3MM8',

    // Terms
    termsAndConditions: 'https://www.neox.energy/terms/',

    // Policy
    privacyPolicy: 'https://www.neox.energy/privacy/'
};
